"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Response = void 0;
var Response;
(function (Response) {
    Response[Response["Approved"] = 1] = "Approved";
    Response[Response["ReviewedAsNoted"] = 2] = "ReviewedAsNoted";
    Response[Response["NoExceptions"] = 3] = "NoExceptions";
    Response[Response["Rejected"] = 4] = "Rejected";
    Response[Response["ReviseAndResubmit"] = 5] = "ReviseAndResubmit";
    Response[Response["Void"] = 6] = "Void";
    Response[Response["NoActionTaken"] = 7] = "NoActionTaken";
    Response[Response["Reviewed"] = 8] = "Reviewed";
})(Response = exports.Response || (exports.Response = {}));
//# sourceMappingURL=Response.js.map